@if (hasActiveConnection$ | async) {
    <adapt-dashboard-element name="Roles"
                             data-test="person-profile-roles">
        <div adapt-dashboard-title-buttons
             *adaptIfAuthorised="ManagePositionAndRoles; entity: person$ | async">
            @if (editMode) {
                <button adaptButton="editBorderless"
                        (click)="editRoles()"></button>
            }
        </div>
        <ng-container *adaptLoadingUntilFirstEmit="let roleConnections of roleConnections$">
            @if (roleConnections.length > 0) {
                @for (roleConnection of roleConnections; track roleConnection) {
                    <div class="d-flex flex-row gap-2 align-items-baseline">
                        <adapt-link-role [role]="roleConnection.role"></adapt-link-role>
                        @if (roleConnection.handoverStatus) {
                            <adapt-display-role-connection-handover-status
                                                                           [roleConnection]="roleConnection"></adapt-display-role-connection-handover-status>
                        }
                        <small>Started {{ roleConnection.startDate | adaptDate }}</small>
                    </div>
                }
            } @else {
                This person does not have any active roles in the organisation
            }
        </ng-container>
    </adapt-dashboard-element>
}
